// Panel de plataforma para multi-tenencia (una cuenta = una base de datos
// separada). Aislado a proposito de "kofides_session" (login real de
// Kofides) y de "sigte_platform_session" (plataforma SIGTE) -- este panel
// TODAVIA no tiene login propio (ver kofides_admin_api.py), es solo para
// probar el mecanismo de creacion de cuentas.

export var KOFIDES_ADMIN_API = "/api/kofides-admin";

export function kofidesAdminApiFetch(path, opts) {
  opts = opts || {};
  var headers = Object.assign({}, opts.headers);
  if (!(opts.body instanceof FormData)) {
    headers["Content-Type"] = headers["Content-Type"] || "application/json";
  }
  return fetch(KOFIDES_ADMIN_API + path, Object.assign({}, opts, { headers: headers }));
}

export async function kofidesAdminApiFetchChecked(path, opts) {
  var r = await kofidesAdminApiFetch(path, opts);
  var body = null;
  try {
    body = await r.json();
  } catch (e) {
    body = null;
  }
  if (!r.ok) {
    var msg = (body && body.error) ? body.error : "Error inesperado del servidor (" + r.status + ").";
    throw new Error(msg);
  }
  return body;
}
